import type { AdLinkUpdateSelectedTemplateResponseAction } from './adLinkUpdateSelectedTemplate.action';
import type { ArchiveAdLinkResponseAction } from './archiveAdLink.action';
import type { BulkCreateAdLinksResponseAction } from './bulkCreateAdLinks.action';
import type { ClearAdLinkResponseAction } from './clearAdLink.action';
import type { ClearCreatedAdLinkResponseAction } from './clearCreatedAdLink.action';
import type { ClearSelectedAdLinkResponseAction } from './clearSelectedAdLink.action';
import type { CreateAdLinkResponseAction } from './createAdLink.action';
import type { DeleteAdLinkResponseAction } from './deleteAdLink.action';
import type { FetchAdLinkResponseAction } from './fetchAdLink.action';
import type { FetchAdLinkCollectionsResponseAction } from './fetchAdLinkCollections.action';
import type { FetchAdLinkTemplateResponseAction } from './fetchAdLinkTemplate.action';
import type { FetchAvailableAdPartnersResponseAction } from './fetchAvailableAdPartners.action';
import type { FetchCampaignOptionsResponseAction } from './fetchCampaignOptions.action';
import type { FetchChannelOptionsResponseAction } from './fetchChannelOptions.action';
import type { SearchAndroidAppNameResponseAction } from './searchAndroidAppName.action';
import type { SearchIosAppNameResponseAction } from './searchIosAppName.action';
import type { UpdateAliasResponseAction } from './updateAlias.action';
import type { UpdateAndroidResponseAction } from './updateAndroid.action';
import type { UpdateAndroidRedirectResponseAction } from './updateAndroidRedirect.action';
import type { UpdateCampaignResponseAction } from './updateCampaign.action';
import type { UpdateChannelResponseAction } from './updateChannel.action';
import type { UpdateDesktopResponseAction } from './updateDesktop.action';
import type { UpdateDesktopRedirectResponseAction } from './updateDesktopRedirect.action';
import type { UpdateEditedAdLinkResponseAction } from './updateEditedAdLink.action';
import type { UpdateIosResponseAction } from './updateIos.action';
import type { UpdateIosRedirectResponseAction } from './updateIosRedirect.action';
import type { UpdateIsAnalyticsTagsStepVisitedResponseAction } from './updateIsAnalyticsTagsStepVisited.action';
import type { UpdateIsBlacklistErrorResponseAction } from './updateIsBlacklistError.action';
import type { UpdateIsEditingResponseAction } from './updateIsEditing.action';
import type { UpdateIsGeneralStepVisitedResponseAction } from './updateIsGeneralStepVisited.action';
import type { UpdateIsLinkDataStepVisitedResponseAction } from './updateIsLinkDataStepVisited.action';
import type { UpdateIsRedirectsStepVisitedResponseAction } from './updateIsRedirectsStepVisited.action';
import type { UpdateKindResponseAction } from './updateKind.action';
import type { UpdateLinkDataResponseAction } from './updateLinkData.action';
import type { UpdateOriginalWebUrlResponseAction } from './updateOriginalWebUrl.action';
import type { UpdateOsPlatformResponseAction } from './updateOsPlatform.action';
import type { UpdatePartnerResponseAction } from './updatePartner.action';
import type { UpdateSelectedAdLinkResponseAction } from './updateSelectedAdLink.action';
import type { UpdateStepResponseAction } from './updateStep.action';
import type { UpdateTagsResponseAction } from './updateTags.action';
import type { UpdateTitleResponseAction } from './updateTitle.action';

export * from './adLinkUpdateSelectedTemplate.action';
export * from './archiveAdLink.action';
export * from './bulkCreateAdLinks.action';
export * from './clearAdLink.action';
export * from './clearCreatedAdLink.action';
export * from './clearSelectedAdLink.action';
export * from './createAdLink.action';
export * from './deleteAdLink.action';
export * from './fetchAdLink.action';
export * from './fetchAdLinkCollections.action';
export * from './fetchAdLinkTemplate.action';
export * from './fetchAvailableAdPartners.action';
export * from './fetchCampaignOptions.action';
export * from './fetchChannelOptions.action';
export * from './searchAndroidAppName.action';
export * from './searchIosAppName.action';
export * from './updateAlias.action';
export * from './updateAndroid.action';
export * from './updateAndroidRedirect.action';
export * from './updateCampaign.action';
export * from './updateChannel.action';
export * from './updateDesktop.action';
export * from './updateDesktopRedirect.action';
export * from './updateEditedAdLink.action';
export * from './updateIos.action';
export * from './updateIosRedirect.action';
export * from './updateIsAnalyticsTagsStepVisited.action';
export * from './updateIsBlacklistError.action';
export * from './updateIsEditing.action';
export * from './updateIsGeneralStepVisited.action';
export * from './updateIsLinkDataStepVisited.action';
export * from './updateIsRedirectsStepVisited.action';
export * from './updateKind.action';
export * from './updateLinkData.action';
export * from './updateOriginalWebUrl.action';
export * from './updateOsPlatform.action';
export * from './updatePartner.action';
export * from './updateSelectedAdLink.action';
export * from './updateStep.action';
export * from './updateTags.action';
export * from './updateTitle.action';

export type LinkHubCreatorAction =
  | AdLinkUpdateSelectedTemplateResponseAction
  | ArchiveAdLinkResponseAction
  | BulkCreateAdLinksResponseAction
  | ClearAdLinkResponseAction
  | ClearCreatedAdLinkResponseAction
  | ClearSelectedAdLinkResponseAction
  | CreateAdLinkResponseAction
  | DeleteAdLinkResponseAction
  | FetchAdLinkResponseAction
  | FetchAdLinkCollectionsResponseAction
  | FetchAdLinkTemplateResponseAction
  | FetchAvailableAdPartnersResponseAction
  | FetchCampaignOptionsResponseAction
  | FetchChannelOptionsResponseAction
  | SearchAndroidAppNameResponseAction
  | SearchIosAppNameResponseAction
  | UpdateAliasResponseAction
  | UpdateAndroidResponseAction
  | UpdateAndroidRedirectResponseAction
  | UpdateCampaignResponseAction
  | UpdateChannelResponseAction
  | UpdateDesktopResponseAction
  | UpdateDesktopRedirectResponseAction
  | UpdateEditedAdLinkResponseAction
  | UpdateIosResponseAction
  | UpdateIosRedirectResponseAction
  | UpdateIsAnalyticsTagsStepVisitedResponseAction
  | UpdateIsBlacklistErrorResponseAction
  | UpdateIsEditingResponseAction
  | UpdateIsEditingResponseAction
  | UpdateIsGeneralStepVisitedResponseAction
  | UpdateIsLinkDataStepVisitedResponseAction
  | UpdateIsRedirectsStepVisitedResponseAction
  | UpdateKindResponseAction
  | UpdateLinkDataResponseAction
  | UpdateOriginalWebUrlResponseAction
  | UpdateOsPlatformResponseAction
  | UpdatePartnerResponseAction
  | UpdateSelectedAdLinkResponseAction
  | UpdateStepResponseAction
  | UpdateTagsResponseAction
  | UpdateTitleResponseAction;
